
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_l0dv0_151le_142",
  "with-toolbar": "awsui_with-toolbar_l0dv0_151le_176",
  "header": "awsui_header_l0dv0_151le_180",
  "list--with-icons": "awsui_list--with-icons_l0dv0_151le_193",
  "header-link": "awsui_header-link_l0dv0_151le_197",
  "header-link--has-logo": "awsui_header-link--has-logo_l0dv0_151le_208",
  "header-link-text": "awsui_header-link-text_l0dv0_151le_208",
  "header-logo": "awsui_header-logo_l0dv0_151le_213",
  "header-logo--stretched": "awsui_header-logo--stretched_l0dv0_151le_219",
  "items-control": "awsui_items-control_l0dv0_151le_224",
  "list-container": "awsui_list-container_l0dv0_151le_229",
  "divider-header": "awsui_divider-header_l0dv0_151le_237",
  "root--collapsed": "awsui_root--collapsed_l0dv0_151le_241",
  "list": "awsui_list_l0dv0_151le_193",
  "list-variant-root": "awsui_list-variant-root_l0dv0_151le_254",
  "list-variant-root--first": "awsui_list-variant-root--first_l0dv0_151le_261",
  "list-variant-root--collapsed": "awsui_list-variant-root--collapsed_l0dv0_151le_264",
  "list-variant-expandable-link-group": "awsui_list-variant-expandable-link-group_l0dv0_151le_271",
  "list-variant-expandable-link-group--collapsed": "awsui_list-variant-expandable-link-group--collapsed_l0dv0_151le_277",
  "list-variant-section": "awsui_list-variant-section_l0dv0_151le_281",
  "list-variant-section--collapsed": "awsui_list-variant-section--collapsed_l0dv0_151le_284",
  "list-variant-link-group": "awsui_list-variant-link-group_l0dv0_151le_293",
  "list-variant-link-group--collapsed": "awsui_list-variant-link-group--collapsed_l0dv0_151le_296",
  "link-group-children": "awsui_link-group-children_l0dv0_151le_300",
  "link-group-children--collapsed": "awsui_link-group-children--collapsed_l0dv0_151le_304",
  "link-group-children-inner": "awsui_link-group-children-inner_l0dv0_151le_308",
  "link-group-children-inner--expanded": "awsui_link-group-children-inner--expanded_l0dv0_151le_314",
  "link-group-children-inner--settled": "awsui_link-group-children-inner--settled_l0dv0_151le_317",
  "list-variant-section-group": "awsui_list-variant-section-group_l0dv0_151le_321",
  "list-variant-section-group--collapsed": "awsui_list-variant-section-group--collapsed_l0dv0_151le_327",
  "list-item": "awsui_list-item_l0dv0_151le_331",
  "list-item--collapsed": "awsui_list-item--collapsed_l0dv0_151le_344",
  "list-item--link-with-info": "awsui_list-item--link-with-info_l0dv0_151le_350",
  "list-item--group": "awsui_list-item--group_l0dv0_151le_355",
  "section": "awsui_section_l0dv0_151le_355",
  "section-group": "awsui_section-group_l0dv0_151le_356",
  "expandable-link-group": "awsui_expandable-link-group_l0dv0_151le_361",
  "section--no-ident": "awsui_section--no-ident_l0dv0_151le_364",
  "section--expand-icon-end": "awsui_section--expand-icon-end_l0dv0_151le_364",
  "expandable-link-group--no-ident": "awsui_expandable-link-group--no-ident_l0dv0_151le_365",
  "expandable-link-group--expand-icon-end": "awsui_expandable-link-group--expand-icon-end_l0dv0_151le_366",
  "section--collapsed": "awsui_section--collapsed_l0dv0_151le_369",
  "expandable-link-group--collapsed": "awsui_expandable-link-group--collapsed_l0dv0_151le_370",
  "expandable-link-group--active": "awsui_expandable-link-group--active_l0dv0_151le_385",
  "item-icon": "awsui_item-icon_l0dv0_151le_389",
  "refresh": "awsui_refresh_l0dv0_151le_410",
  "section-header": "awsui_section-header_l0dv0_151le_431",
  "section-group-title": "awsui_section-group-title_l0dv0_151le_446",
  "section-group-title--collapsed": "awsui_section-group-title--collapsed_l0dv0_151le_454",
  "link": "awsui_link_l0dv0_151le_300",
  "link-active": "awsui_link-active_l0dv0_151le_486",
  "link--collapsed": "awsui_link--collapsed_l0dv0_151le_493",
  "header-link-active": "awsui_header-link-active_l0dv0_151le_561",
  "link-text-wrapper-content": "awsui_link-text-wrapper-content_l0dv0_151le_590",
  "link-text-wrapper": "awsui_link-text-wrapper_l0dv0_151le_590",
  "link-text-wrapper--collapsed": "awsui_link-text-wrapper--collapsed_l0dv0_151le_604",
  "label-text": "awsui_label-text_l0dv0_151le_609",
  "label-text--collapsed": "awsui_label-text--collapsed_l0dv0_151le_616",
  "info": "awsui_info_l0dv0_151le_622",
  "item-icon--collapsed": "awsui_item-icon--collapsed_l0dv0_151le_631",
  "external-icon": "awsui_external-icon_l0dv0_151le_635",
  "divider": "awsui_divider_l0dv0_151le_237",
  "divider-default": "awsui_divider-default_l0dv0_151le_643",
  "divider--collapsed": "awsui_divider--collapsed_l0dv0_151le_647"
};
  